(() => {
  'use strict';
  const root = document.documentElement;
  if (root.dataset.hsxmBound) return;
  root.dataset.hsxmBound = 'true';
  const phone = matchMedia('(max-width:800px)');
  const messages = (() => {
    try { return JSON.parse(document.querySelector('[data-hsx-ui-messages]')?.textContent || '{}'); }
    catch { return {}; }
  })();
  const bound = new WeakSet();
  let focusFrame = 0, tableFrame = 0, viewportBaseline = innerHeight;

  function closeProductMenu(nav, restoreFocus = false) {
    nav.removeAttribute('data-hsxm-open');
    const button = nav.querySelector('[data-hsxm-sections]');
    button?.setAttribute('aria-expanded', 'false');
    const symbol = button?.querySelector('[aria-hidden]');
    if (symbol) symbol.textContent = '+';
    if (phone.matches && nav.hasAttribute('data-hsxp-fixed-nav')) {
      root.style.setProperty('--hsxp-product-nav-height', Math.ceil(nav.getBoundingClientRect().height) + 'px');
    }
    if (restoreFocus) button?.focus();
  }

  function navigation(scope) {
    scope.querySelectorAll('[data-hsx2-menu]').forEach(menu => {
      if (bound.has(menu)) return;
      bound.add(menu);
      const summary = menu.querySelector('summary');
      const sync = () => {
        summary?.setAttribute('aria-expanded', String(menu.open));
        const label = menu.open ? messages.mobile_close : messages.mobile_open;
        if (label) summary?.setAttribute('aria-label', label);
        if (menu.open) document.querySelectorAll('.hsxv-jump[data-hsxm-open]').forEach(nav => closeProductMenu(nav));
      };
      menu.addEventListener('toggle', sync);
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) menu.open = false;
      });
      sync();
    });
    scope.querySelectorAll('.hsxv-jump').forEach(nav => {
      if (bound.has(nav)) return;
      const button = nav.querySelector('[data-hsxm-sections]');
      if (!button) return;
      bound.add(nav);
      button.hidden = false;
      nav.setAttribute('data-hsxm-ready', '');
      button.addEventListener('click', () => {
        const open = !nav.hasAttribute('data-hsxm-open');
        nav.toggleAttribute('data-hsxm-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.querySelector('[aria-hidden]').textContent = open ? '−' : '+';
        document.querySelectorAll('[data-hsx2-menu][open]').forEach(menu => { menu.open = false; });
      });
      nav.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (link && phone.matches && !event.metaKey && !event.ctrlKey && !event.shiftKey) closeProductMenu(nav);
      });
      nav.addEventListener('keydown', event => {
        if (event.key === 'Escape' && nav.hasAttribute('data-hsxm-open')) {
          event.preventDefault();
          closeProductMenu(nav, true);
        }
      });
      closeProductMenu(nav);
    });
  }

  function footer(scope) {
    scope.querySelectorAll('.hsxm-footer-group').forEach(group => { group.open = !phone.matches; });
  }

  function tableSizes() {
    tableFrame = 0;
    document.querySelectorAll('.hsxm-table-wrap').forEach(wrap => {
      const scrolls = wrap.scrollWidth > wrap.clientWidth + 1;
      if (scrolls) {
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        if (messages.mobile_table) wrap.setAttribute('aria-label', messages.mobile_table);
      } else {
        wrap.removeAttribute('tabindex');
        wrap.removeAttribute('role');
        wrap.removeAttribute('aria-label');
      }
    });
  }

  function tables(scope) {
    scope.querySelectorAll('.hsx-prose table').forEach(table => {
      if (table.closest('.hsx-table-wrap,.hsxm-table-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'hsxm-table-wrap';
      table.before(wrap);
      wrap.append(table);
    });
    tableSizes();
  }

  function themeLabels() {
    document.querySelectorAll('[data-hsxm-theme]').forEach(button => {
      const text = root.dataset.theme === 'dark' ? messages.mobile_light : messages.mobile_dark;
      if (!text) return;
      button.setAttribute('aria-label', text);
      const label = button.querySelector('[data-hsxm-theme-label]');
      if (label) label.textContent = text;
    });
  }

  function focusedField() {
    focusFrame = 0;
    const focused=!!document.activeElement?.matches('input:not([type=checkbox]):not([type=radio]):not([type=hidden]):not([type=submit]),textarea,select');
    root.classList.toggle('hsxm-field-focus',focused);
    if(!focused)viewportBaseline=innerHeight;
    root.classList.toggle('hsxm-keyboard-open',phone.matches&&focused&&(window.visualViewport?.height||innerHeight)<viewportBaseline-120);
  }

  function initialize(scope = document) {
    navigation(scope);
    footer(scope);
    scope.querySelectorAll('[data-hsxm-filter-panel]').forEach(panel=>{panel.open=!phone.matches;});
    tables(scope);
    themeLabels();
  }

  phone.addEventListener('change', () => {
    footer(document);
    document.querySelectorAll('[data-hsxm-filter-panel]').forEach(panel=>{const summary=panel.querySelector('summary');if(phone.matches&&panel.contains(document.activeElement))summary?.focus({preventScroll:true});panel.open=!phone.matches;});
    document.querySelectorAll('.hsxv-jump').forEach(nav => closeProductMenu(nav));
    tableSizes();
  });
  const themeObserver = new MutationObserver(themeLabels);
  themeObserver.observe(root, {attributes:true, attributeFilter:['data-theme']});
  document.addEventListener('click', event => {
    document.querySelectorAll('.hsxv-jump[data-hsxm-open]').forEach(nav => {
      if (!nav.contains(event.target)) closeProductMenu(nav);
    });
  });
  ['focusin', 'focusout'].forEach(type => document.addEventListener(type, () => {
    if (!focusFrame) focusFrame = requestAnimationFrame(focusedField);
  }));
  window.visualViewport?.addEventListener('resize',focusedField,{passive:true});
  addEventListener('resize', () => { focusedField(); if (!tableFrame) tableFrame = requestAnimationFrame(tableSizes); }, {passive:true});
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
})();

(()=>{
 'use strict';
 const records=new Map(),small=matchMedia('(max-width:60rem)');
 const reduced=()=>matchMedia('(prefers-reduced-motion:reduce)').matches||document.documentElement.dataset.hsxMotion==='false';
 function enhance(scope=document){
  for(const [header,record] of records)if(!header.isConnected){record.dispose();records.delete(header);}
  scope.querySelectorAll('.hsx-v2-header').forEach(header=>{
   if(records.has(header)||!window.HTMLDialogElement?.prototype.showModal)return;
   const launch=header.querySelector('[data-hsxm-menu-launch]'),dialog=launch&&document.getElementById(launch.getAttribute('aria-controls')),fallback=header.querySelector('[data-hsx2-menu]');
   if(!launch||!dialog)return;
   const controller=new AbortController(),options={signal:controller.signal};let animation=null;
   const panels=[...dialog.querySelectorAll('[data-hsxm-menu-panel]')],content=dialog.querySelector('.hsxm-menu-content');
   document.body.append(dialog);header.setAttribute('data-hsxm-drawer-ready','');launch.hidden=false;if(fallback)fallback.hidden=true;
   const panel=(name,focus=true)=>{
    const next=panels.find(p=>p.dataset.hsxmMenuPanel===name);if(!next)return;
    animation?.cancel();panels.forEach(p=>{p.hidden=p!==next;});
    dialog.querySelectorAll('[data-hsxm-menu-next]').forEach(button=>button.setAttribute('aria-expanded',String(button.dataset.hsxmMenuNext===name)));
    const title=next.querySelector('h2');if(title?.id)dialog.setAttribute('aria-labelledby',title.id);
    content.scrollTop=0;
    if(focus)(next.querySelector('[data-hsxm-menu-back]')||dialog.querySelector('[data-hsxm-menu-close]'))?.focus({preventScroll:true});
    if(!reduced()&&next.animate)animation=next.animate([{opacity:.6,transform:'translateX(16px)'},{opacity:1,transform:'none'}],{duration:280,easing:'cubic-bezier(.22,.61,.36,1)'});
   };
   const close=(restore=true)=>{if(dialog.open)dialog.close();document.body.classList.remove('hsxm-menu-open');launch.setAttribute('aria-expanded','false');if(restore&&launch.isConnected)launch.focus({preventScroll:true});};
   launch.addEventListener('click',()=>{
    document.querySelectorAll('.hsxv-jump[data-hsxm-open]').forEach(nav=>{nav.removeAttribute('data-hsxm-open');nav.querySelector('[data-hsxm-sections]')?.setAttribute('aria-expanded','false');});
    panel('main',false);dialog.showModal();document.body.classList.add('hsxm-menu-open');launch.setAttribute('aria-expanded','true');dialog.querySelector('[data-hsxm-menu-close]').focus({preventScroll:true});
   },options);
   dialog.addEventListener('click',event=>{
    const next=event.target.closest('[data-hsxm-menu-next]');if(next){panel(next.dataset.hsxmMenuNext);return;}
    if(event.target.closest('[data-hsxm-menu-back]')){const previous=panels.find(p=>!p.hidden)?.dataset.hsxmMenuPanel;panel('main',false);dialog.querySelector('[data-hsxm-menu-next="'+previous+'"]')?.focus({preventScroll:true});return;}
    if(event.target.closest('[data-hsxm-menu-close]')){close();return;}
    if(event.target.closest('a')){close(false);return;}
    if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}
   },options);
   dialog.addEventListener('cancel',event=>{event.preventDefault();close();},options);
   dialog.addEventListener('close',()=>{document.body.classList.remove('hsxm-menu-open');launch.setAttribute('aria-expanded','false');},options);
   small.addEventListener('change',()=>{if(!small.matches)close(false);},options);
   records.set(header,{dispose(){controller.abort();animation?.cancel();close(false);dialog.remove();header.removeAttribute('data-hsxm-drawer-ready');launch.hidden=true;if(fallback)fallback.hidden=false;}});
  });
 }
 document.addEventListener('shopify:section:load',event=>enhance(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [header,record] of records)if(event.target.contains(header)){record.dispose();records.delete(header);}});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>enhance(),{once:true});else enhance();
})();
